import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import './config/pastelTheme.css';

// Importar páginas
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Setup from './pages/Setup';
import Reports from './pages/Reports';
import Withdrawals from './pages/Withdrawals';
import VerifyEmail from './pages/VerifyEmail';
import ResetPassword from './pages/ResetPassword';
import EmailConfig from './pages/EmailConfig';
import NotFound from './pages/NotFound';
import SequelizeDashboard from './pages/SequelizeDashboard';
import KnowledgeBase from './pages/KnowledgeBase';
import KnowledgeDashboard from './pages/KnowledgeDashboard';
import DocumentationPage from './pages/DocumentationPage';
import Calendar from './pages/Calendar';
import ErrorLogs from './pages/ErrorLogs';
import DockerLogs from './pages/DockerLogs';
import ApiErrorLogs from './pages/ApiErrorLogs';
import SavedSettings from './pages/SavedSettings';
import TesteDesign from './pages/TesteDesign';
import ReadmeChat from './pages/ReadmeChat';
import Documentation from './pages/admin/Documentation';
import DocumentationDetail from './pages/admin/DocumentationDetail';
import Settings from './pages/Settings';
import Agents from './pages/Agents';

// Componente para rotas protegidas
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

// Componente para rotas de administrador
const AdminRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const isAdmin = user.email === 'admin@example.com';
  
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  
  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }
  
  return children;
};

function App() {
  return (
    <>
      <ToastContainer position="top-right" autoClose={5000} />
      <Routes>
        {/* Rotas públicas */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        
        {/* Rotas protegidas */}
        <Route path="/" element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } />
        <Route path="/setup" element={
          <ProtectedRoute>
            <Setup />
          </ProtectedRoute>
        } />
        <Route path="/reports" element={
          <ProtectedRoute>
            <Reports />
          </ProtectedRoute>
        } />
        <Route path="/saved-settings" element={
          <ProtectedRoute>
            <SavedSettings />
          </ProtectedRoute>
        } />
        <Route path="/withdrawals" element={
          <ProtectedRoute>
            <Withdrawals />
          </ProtectedRoute>
        } />
        <Route path="/calendar" element={
          <ProtectedRoute>
            <Calendar />
          </ProtectedRoute>
        } />
        <Route path="/agents" element={
          <ProtectedRoute>
            <Agents />
          </ProtectedRoute>
        } />
        <Route path="/teste-design" element={
          <ProtectedRoute>
            <TesteDesign />
          </ProtectedRoute>
        } />
        <Route path="/system-settings" element={
          <ProtectedRoute>
            <Settings />
          </ProtectedRoute>
        } />
        
        {/* Rotas de administrador */}
        <Route path="/admin/email-config" element={
          <AdminRoute>
            <EmailConfig />
          </AdminRoute>
        } />
        <Route path="/admin/sequelize" element={
          <AdminRoute>
            <SequelizeDashboard />
          </AdminRoute>
        } />
        <Route path="/admin/knowledge-base" element={
          <AdminRoute>
            <KnowledgeBase />
          </AdminRoute>
        } />
        <Route path="/admin/knowledge-dashboard" element={
          <AdminRoute>
            <KnowledgeDashboard />
          </AdminRoute>
        } />
        <Route path="/admin/documentation" element={<Documentation />} />
        <Route path="/admin/documentation/:id" element={<DocumentationDetail />} />
        <Route path="/admin/error-logs" element={
          <AdminRoute>
            <ErrorLogs />
          </AdminRoute>
        } />
        <Route path="/admin/docker-logs" element={
          <AdminRoute>
            <DockerLogs />
          </AdminRoute>
        } />
        <Route path="/admin/api-error-logs" element={
          <AdminRoute>
            <ApiErrorLogs />
          </AdminRoute>
        } />
        
        {/* Rota para Readme/Documentação */}
        <Route path="/readme-chat" element={
          <ProtectedRoute>
            <ReadmeChat />
          </ProtectedRoute>
        } />
        
        {/* Rota 404 */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
}

export default App; 